import React from "react";
import InvoiceService from "../../../app/data/invoice/invoiceService";
import DownloadButton from "../../../ui-components/download-button/downloadButton";
import { useExport } from "../../../hooks/useExport";

export interface PodDownloadButtonProps {
  invoiceNumber: number;
}

const invoiceDocumentsService = InvoiceService.getInstance();

const PodDownloadButton: React.FC<PodDownloadButtonProps> = ({ invoiceNumber }) => {
  const exportPod = () => invoiceDocumentsService.exportPODDocument(invoiceNumber);

  const {
    getExport,
    exportState
  } = useExport(    
    exportPod,
    "id",
  );

  return (
    <DownloadButton
        title="POD"
        onClick={(e) => {
          e.stopPropagation();
          getExport();
        }}
        spinner={exportState?.exportStarted}
      />
  )
}

export default PodDownloadButton;